import $ from 'cash-dom';

export default () => {
  const $images = $('.js-show-image');

  if ($images.length) {
    const imageAnimate = () => {
      $images.each((i, el) => {
        const $image = $(el);
        const imageTop = $image.offset().top;
        const imageHeightStart = $image.height() / 2;
        const scrollBottom = window.pageYOffset + $(window).height();
        if (scrollBottom >= imageTop + imageHeightStart) {
          $image.addClass('is-active');
        }
      });
    };

    imageAnimate();

    $(window).on('scroll', () => {
      imageAnimate();
    });
  }
};
